<template>
    <div class="openings-card">
        <div class="openings-card__head">
            <div>
                <h1 class="openings-card__title">Openings</h1>
                <p class="openings-card__time">⏰ Starts {{ currentFD.time }} SGT</p>
            </div>
            <UpdateFDDetails></UpdateFDDetails>
        </div>

        <table class="openings-table">
            <thead>
                <tr>
                    <th>Spots for</th>
                    <th class="ta-center">Total</th>
                    <th class="ta-center">Open</th>
                </tr>
            </thead>
            <tbody v-if="showStatsFor == 'regular' || showStatsFor == 'all'">
                <tr>
                    <td>🚗 Redhill – Driver</td>
                    <td class="ta-center">{{ currentFD.volunteers_drivers_required }}</td>
                    <td class="ta-center">
                        <span class="open-badge" :class="badgeClass(currentFD.volunteers_drivers_remaining)">
                            {{ openCount(currentFD.volunteers_drivers_remaining) }}
                        </span>
                    </td>
                </tr>
                <tr>
                    <td>🚶 Redhill – Walking</td>
                    <td class="ta-center">{{ currentFD.volunteers_others_required }}</td>
                    <td class="ta-center">
                        <span class="open-badge" :class="badgeClass(currentFD.volunteers_others_remaining)">
                            {{ openCount(currentFD.volunteers_others_remaining) }}
                        </span>
                    </td>
                </tr>
                <tr>
                    <td>🚶 TBR – Walking</td>
                    <td class="ta-center">{{ currentFD.tbr_volunteers_required ?? 0 }}</td>
                    <td class="ta-center">
                        <span class="open-badge" :class="badgeClass(currentFD.tbr_volunteers_remaining ?? 0)">
                            {{ openCount(currentFD.tbr_volunteers_remaining ?? 0) }}
                        </span>
                    </td>
                </tr>
            </tbody>
            <tbody v-if="currentFD.sponsor && (showStatsFor == 'sponsor' || showStatsFor == 'all')">
                <tr :class="[showStatsFor == 'all' ? 'green' : '']">
                    <td>🚗 Sponsor – Driver</td>
                    <td class="ta-center">{{ currentFD.sponsor_volunteers_drivers_required }}</td>
                    <td class="ta-center">
                        <span class="open-badge" :class="badgeClass(currentFD.sponsor_volunteers_drivers_remaining)">
                            {{ openCount(currentFD.sponsor_volunteers_drivers_remaining) }}
                        </span>
                    </td>
                </tr>
                <tr :class="[showStatsFor == 'all' ? 'green' : '']">
                    <td>🚶 Sponsor – Walking</td>
                    <td class="ta-center">{{ currentFD.sponsor_volunteers_others_required }}</td>
                    <td class="ta-center">
                        <span class="open-badge" :class="badgeClass(currentFD.sponsor_volunteers_others_remaining)">
                            {{ openCount(currentFD.sponsor_volunteers_others_remaining) }}
                        </span>
                    </td>
                </tr>
                <tr :class="[showStatsFor == 'all' ? 'green' : '']">
                    <td>🚶 Sponsor TBR – Walking</td>
                    <td class="ta-center">{{ currentFD.sponsor_tbr_volunteers_required ?? 0 }}</td>
                    <td class="ta-center">
                        <span class="open-badge" :class="badgeClass(currentFD.sponsor_tbr_volunteers_remaining ?? 0)">
                            {{ openCount(currentFD.sponsor_tbr_volunteers_remaining ?? 0) }}
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import UpdateFDDetails from '@/components/fd/UpdateFDDetails.vue';

export default {
    components: {
        UpdateFDDetails
    },
    props: {
        showStatsFor: {
            type: String,
            default: 'all'
        }
    },
    computed: {
        currentFD() {
            return this.$store.getters['fd/getCurrentFD'];
        }
    },
    methods: {
        openCount(remaining) {
            return remaining < 1 ? 0 : remaining;
        },
        badgeClass(remaining) {
            return remaining < 1 ? 'open-badge--full' : 'open-badge--open';
        }
    }
}
</script>

<style scoped>
.openings-card {
    background: #fff;
    border-radius: 16px;
    padding: 1.1rem 1.25rem 0.6rem;
    box-shadow: 0 6px 20px -12px rgba(15, 23, 42, 0.25);
    border: 1px solid #eef0f4;
}

.openings-card__head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
}

.openings-card__title {
    font-size: 1.15rem;
    font-weight: 700;
    color: #1f2937;
    margin: 0;
}

.openings-card__time {
    font-size: 0.78rem;
    color: #6b7280;
    margin-top: 0.1rem;
}

.openings-table {
    width: 100%;
    border-collapse: collapse;
}

.openings-table th {
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #9ca3af;
    text-align: left;
    padding: 0.4rem 0.5rem;
    border-bottom: 1px solid #eef0f4;
}

.openings-table td {
    padding: 0.7rem 0.5rem;
    border-bottom: 1px solid #f3f4f6;
    color: #374151;
    font-size: 0.95rem;
}

.openings-table tbody tr:last-child td {
    border-bottom: none;
}

.openings-table tr.green td {
    background: #ecfdf5;
}

.ta-center {
    text-align: center;
}

.open-badge {
    display: inline-block;
    min-width: 2rem;
    padding: 0.15rem 0.55rem;
    border-radius: 999px;
    font-weight: 700;
    font-size: 0.85rem;
}

.open-badge--open {
    color: #047857;
    background: #d1fae5;
}

.open-badge--full {
    color: #9ca3af;
    background: #f3f4f6;
}
</style>
